<!--平台优势-->
<template>
  <div class="platform-advantages-new">
    <img :src="ossPath + '/pages/home/advantage/title.png'" alt="" style="margin-top: 60px;position: relative;left: 50%;transform: translateX(-50%)">
    <div class="advantage-list">
      <div
        v-for="item in advantageList"
        :key="item.label"
        class="advantage-card">
        <img :src="item.icon" alt="" :style="item.iconStyle">
        <div class="advantage-card--label">{{ item.label }}</div>
        <div class="advantage-card--text">{{ item.text }}</div>
      </div>
    </div>
  </div>
  <!--<div class="platform-advantages">
    <div class="page-size-container">
      <img class="advantages-title" style="margin-bottom: 98px;" :src="ossPath + '/pages/home/advantage/our-advantage.png'" alt="">
      <div class="panel-list">
        <div
          class="panel-item"
          :class="{ 'is-active': activeIndex === index }"
          @mouseenter="togglePanel(index)"
          v-for="(item, index) in panels"
          :key="index"
        >
          <transition name="fade">
            <div class="cover-box" v-show="activeIndex !== index">
              <img class="image-cover" :src="item.image" alt="">
              <div class="title">{{ item.title }}</div>
            </div>
          </transition>
          <transition name="fade">
            <div class="details-box" v-show="activeIndex === index">
              <div class="title">{{ item.title }}</div>
              <div class="content">{{ item.content }}</div>
              <img :src="item.image" alt="">
              <div class="link" @click="searchPrice">立即查价></div>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </div>-->
</template>

<script>
export default {
  name: "platformAdvantages",
  data() {
    const ossPath = this.ossPath;

    return {
      activeIndex: 0,
      panels: [
        {
          title: '全球门到门资源',
          image: ossPath + '/pages/home/advantage/icon_1.png',
          content: '提供便捷式全球一键到门服务货代省心，省时，更省事',
        },
        {
          title: '工具社交化',
          image: ossPath + '/pages/home/advantage/icon_2.png',
          content: '提供便捷PC以及小程序跟单分享工具，助力货代轻松收货',
        },
        {
          title: '优选供应商',
          image: ossPath + '/pages/home/advantage/icon_3.png',
          content: '平台专线、分段供应商均隶属于“全球专线联盟”会员单位，经过联盟及平台多方位实地考察评估。为您提供更低的价格更优的服务',
        },
        {
          title: 'SAAS数字化体验',
          image: ossPath + '/pages/home/advantage/icon_4.png',
          content: '深度打磨的SAAS数字化体验，客户一键查价下单跟踪轨迹，供应商一键上传价格，接单，操作轨迹',
        },
        {
          title: '轨迹可视化',
          image: ossPath + '/pages/home/advantage/icon_5.png',
          content: '通过与分段供应商系统集成，可提供门到门全程可视化轨迹以及轨迹失效预警',
        },
        {
          title: '五星服务',
          image: ossPath + '/pages/home/advantage/icon_6.png',
          content: '7*12H在线客服，申请赔付12小时内受理，3个工作日内答复，确认理赔24小时到账',
        }
      ],
      list: [
        { label: "去中心化", text: "创新化的互联网去中心化思想,将传统专线进行拆分,提供可独立选择的分段供应商资源,只为您提供更多个性化服务.", img: ossPath + "/pages/home/advantage-1.png" },
        { label: "工具社交化", text: "提供便捷pc以及小程序拼团分享工具,助力团长轻松开团.", img: ossPath + "/pages/home/advantage-2.png" },
        { label: "供应商直采", text: "直选本地优质分段供应商资源,避免专线层层加价,平台将最优的价格提供给货代客户.", img: ossPath + "/pages/home/advantage-3.png" },
        { label: "saas数字化体验", text: "深度打磨的saas数字化体验,客户一键查价下单跟踪轨迹,供应商一键上传价格,接单,操作轨迹.", img: ossPath + "/pages/home/advantage-4.png" },
        { label: "轨迹可视化", text: "通过与分段供应商系统集成,可提供门到门全程可视化轨迹以及轨迹时效预警.", img: ossPath + "/pages/home/advantage-5.png" },
        { label: "五星服务", text: "7*12H在线客服,申请赔付12小时内受理,3个工作日内答复,确认理赔24小时到账.", img: ossPath + "/pages/home/advantage-6.png" },
      ],
      advantageList: [
        {
          icon: this.ossPath + '/pages/home/advantage/icon_todoor.png',
          label: '一键到门',
          text: '全球门到门资源，提供便捷式全球一键到门服务。货代省心，省时，更省事',
          iconStyle: 'position: absolute;left: 29px;top: 38px'
        },
        {
          icon: this.ossPath + '/pages/home/advantage/icon_instrumentalization.png',
          label: '工具社交化',
          text: '提供便捷PC以及小程序跟单分享工具，助力货代轻松收货',
          iconStyle: 'position: absolute;left: 32px;top: 40px'
        },
        {
          icon: this.ossPath + '/pages/home/advantage/icon_supplier.png',
          label: '优选供应商',
          text: '平台专线、分段供应商均隶属于“全球专线联盟”会员单位，经过联盟及平台多方位实地考察评估。为您提供更低的价格更优的服务',
          iconStyle: 'position: absolute;left: 30px;top: 34px'
        },
        {
          icon: this.ossPath + '/pages/home/advantage/icon_visible.png',
          label: 'SAAS数字化体验',
          text: '深度打磨的SAAS数字化体验，客户一键查价下单跟踪轨迹，供应商一键上传价格，接单，操作轨迹',
          iconStyle: 'position: absolute;left: 23px;top: 43px'
        },
        {
          icon: this.ossPath + '/pages/home/advantage/icon_track.png',
          label: '轨迹可视化',
          text: '通过与分段供应商系统集成，可提供门到门全程可视化轨迹以及轨迹失效预警',
          iconStyle: 'position: absolute;left: 30px;top: 26px'
        },
        {
          icon: this.ossPath + '/pages/home/advantage/icon_service.png',
          label: '五星服务',
          text: '7*12H在线客服，申请赔付12小时内受理，3个工作日内答复，确认理赔24小时到账',
          iconStyle: 'position: absolute;left: 30px;top: 34px'
        }
      ]
    }
  },
  methods: {
    togglePanel(index) {
      this.activeIndex = index
    },
    searchPrice() {
      this.$router.push({
        path: '/placeOrder/placeindexInfo/queryPrice'
      })
    }
  },
  mounted() {
    // const p = document.getElementsByClassName('panel')[0]
    // p.addEventListener('', (e) => {
    //   console.log(e)
    // })
  }
}
</script>

<style lang="scss" scoped>
div, span {
  user-select: none;
}
$ossPath: "https://huodaipin-test.oss-cn-hongkong.aliyuncs.com/web/v1.0.0";
.platform-advantages{
  box-sizing: border-box;
  padding: 50px;
  height: 774px;
  background-image: url(#{$ossPath}/pages/home/advantage/bg.png);
  background-size: 100% 100%;
}

.advantages-title{
  display: block;
  height: auto;
  width: auto;
  margin: 0 auto;
}
//  风琴效果
.panel-list {
  /* 弹性布局 使页面元素水平+垂直居中 */
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 416px;
  margin: 0 auto;
  background-image: url(#{$ossPath}/pages/home/advantage/inner-bg.png);
  background-size: 100% 100%;
}

.panel-item {
  transition: width 0.3s ease;
  overflow: hidden;
  color: #FFFFFF;
  position: relative;
  width: 172px;
  &:not(:last-child){
    border-right: 2px solid #000;
  }
  &.is-active{
    width: 336px;
  }
  .title {
    text-align: center;
    font-size: 24px;
    line-height: 36px;
    height: 72px;
    font-weight: 800;
  }
  .image-cover{
    width: 110px;
    height: 110px;
    border: none;
    object-fit: contain;
  }
  .cover-box{
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .title {
      margin-top: 30px;
    }
  }
  .details-box{
    width: 338px;
    font-size: 16px;
    font-weight: 500;
    .title {
      position: absolute;
      top: 57px;
      left: 42px;
    }
    .content {
      width: 216px;
      position: absolute;
      text-align: left;
      top: 124px;
      left: 41px;
      white-space: break-spaces;
    }
    img {
      position: absolute;
      right: 34px;
      bottom: 73px;
    }
    .link {
      color: #FF344A;
      position: absolute;
      left: 41px;
      bottom: 47px;
      font-size: 14px;
      &:hover {
        cursor: pointer;
      }
    }
  }
}

.panel-heading {
  padding: 10px;
  cursor: pointer;
}

.panel-content {
  padding: 10px;
}

.panel-slide-enter-active,
.panel-slide-leave-active {
  transition: transform 0.3s ease-in-out;
}

.panel-slide-enter {
  transform: translateX(-100%);
}

.panel-slide-leave-to {
  transform: translateX(-100%);
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

.platform-advantages-new {
  width: 100%;
  height: 933px;
  background-image: url(#{$ossPath}/pages/home/advantage/img_advantage_bg.png);
  background-position: center;
  background-size: 1920px 933px;
  .advantage-list {
    width: 1200px;
    margin: 60px auto 0;
    display: flex;
    flex-wrap: wrap;
    .advantage-card {
      width: 364.5px;
      height: 292px;
      margin-right: 53px;
      background: #FFFFFF;
      box-shadow: 0 0 27px 0 rgba(162,52,5,0.2);
      border-radius: 11px;
      border: 1px solid #FFFFFF;
      flex-shrink: 0;
      flex-grow: 0;
      box-sizing: border-box;
      position: relative;
      overflow: hidden;
      transition: .3s ease;
      cursor: default;
      &:nth-child(3n) {
        margin-right: 0;
      }
      &:nth-child(-n + 3) {
        margin-bottom: 53px;
      }
      &::after {
        content: "";
        width: 100%;
        height: 11px;
        position: absolute;
        left: 0;
        bottom: -11px;
        background: #FF4D01;
        transition: all .3s ease;
      }
      &:hover {
        background: linear-gradient(180deg, #FFFFFF 0%, #FDF3EE 100%);
        box-shadow: 0 0 27px 0 rgba(162,52,5,0.2);
        &::after {
          bottom: 0;
        }
      }
      &--label {
        position: absolute;
        left: 27px;
        top: 114px;
        font-size: 20px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #141414;
        line-height: 33px;
      }
      &--text {
        width: 311px;
        position: absolute;
        left: 27px;
        top: 154px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #141414;
        line-height: 26px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/placeOrder/components/platformAdvantages.vue